import { Component, Fragment } from "react";
import "./AdditionalOptions.css";
import { CollapsibleContainer } from "./Container";
import Dropdown from "./controls/Dropdown";
import Switch from "./controls/Switch";
import Units from "./Units";

const makeOptions = (labels) => labels.map((item, index) => ({ label: item, value: index }));

export default class AdditionalOptionsPicker extends Component {
  constructor(props) {
    super(props);

    let deload = 0;
    let skipDeload = true;
    if (props.options.deload !== -1) {
      deload = props.options.deload;
      skipDeload = false;
    }

    let jokerMax = 1;
    let showJoker = false;
    if (props.options.jokerMax !== 0) {
      jokerMax = props.options.jokerMax;
      showJoker = true;
    }

    this.state = {
      deload: deload,
      skipDeload: skipDeload,
      jokerMax: jokerMax,
      showJoker: showJoker,
      lowerBaseText: Boolean(props.options.lowerBase) ? props.options.lowerBase.toString() : "0",
      upperBaseText: Boolean(props.options.upperBase) ? props.options.upperBase.toString() : "0",
    };
  }

  optionsChanged = (optionsUpdate) => {
    const copy = { ...this.props.options };
    this.props.optionsChanged?.(Object.assign(copy, optionsUpdate));
  }

  warmupChanged = (newWarmup) => {
    this.optionsChanged({ warmup: Number(newWarmup) });
  }

  skipDeloadChanged = (newSkipDeload) => {
    this.setState({ skipDeload: !newSkipDeload }, () => {
      this.optionsChanged({ deload: !newSkipDeload ? -1 : this.state.deload });
    });
  }

  deloadChanged = (newDeload) => {
    this.setState({ deload: Number(newDeload) }, () => {
      this.optionsChanged({ deload: this.state.deload });
    });
  }

  showJokerChanged = (newShowJoker) => {
    this.setState({ showJoker: newShowJoker }, () => {
      this.optionsChanged({ jokerMax: newShowJoker ? this.state.jokerMax : 0 });
    });
  }

  jokerMaxChanged = (newJokerMax) => {
    this.setState({ jokerMax: Number(newJokerMax) + 1 }, () => {
      this.optionsChanged({ jokerMax: this.state.jokerMax });
    });
  }

  deloadSkipWarmupChanged = (newVal) => {
    this.optionsChanged({ deloadSkipWarmup: newVal });
  }

  upperBaseChanged = (newUpperBase) => {
    const newText = newUpperBase.target.value;
    this.setState({ upperBaseText: newText }, () => {
      const newVal = parseFloat(newText);
      this.optionsChanged({ upperBase: newVal ? newVal : 0 });
    });
  }

  lowerBaseChanged = (newLowerBase) => {
    const newText = newLowerBase.target.value;
    this.setState({ lowerBaseText: newText }, () => {
      const newVal = parseFloat(newText);
      this.optionsChanged({ lowerBase: newVal ? newVal : 0 });
    });
  }

  render() {
    let unitString;
    if (this.props.unit === Units.Lbs) {
      unitString = "lbs";
    } else {
      unitString = "kg"
    }

    const warmupOptions = makeOptions([
      "Original",
      "Beyond 5/3/1",
    ]);

    const deloadOptions = makeOptions([
      "Deload 1",
      "Deload 2",
      "Deload 3",
      "Deload 4",
      "Deload 5",
      "High Intensity",
    ]);

    const jokerMaxOptions = makeOptions([
      "+5%",
      "+10%",
      "+15%",
      "+20%",
      "+25%",
      "+30%",
    ]);

    const baseWeightsPicker = this.props.options.warmup !== 1 ? null :
      <Fragment>
        <hr className="divider" />
        <h4>Base Weight</h4>
        <label className="form-row">
          Lower Body
          <div>
            <input type="number" className="weight" pattern="[0-9.]*" inputMode="decimal" value={this.state.lowerBaseText} onChange={this.lowerBaseChanged} />
            <span className="unit-string">{unitString}</span>
          </div>
        </label>
        <label className="form-row">
          Upper Body
          <div>
            <input type="number" className="weight" pattern="[0-9.]*" inputMode="decimal" value={this.state.upperBaseText} onChange={this.upperBaseChanged} />
            <span className="unit-string">{unitString}</span>
          </div>
        </label>
      </Fragment>;

    const deloadPicker = this.state.skipDeload ? null :
      <label className="form-row">
        Option<Dropdown values={deloadOptions} value={this.state.deload} onChange={this.deloadChanged} />
      </label>;
    const deloadSkipWarmup = !(!this.state.skipDeload && this.state.deload < 5) ? null :
      <Fragment>
        <hr className="divider" />
        <label className="form-row">
          Skip Warmup
          <Switch checked={this.props.options.deloadSkipWarmup} onChange={this.deloadSkipWarmupChanged} />
        </label>
      </Fragment>
    const jokerMaxPicker = !this.state.showJoker ? null :
      <label className="form-row">
        Up to <Dropdown values={jokerMaxOptions} value={this.state.jokerMax - 1} onChange={this.jokerMaxChanged} />
      </label>;


    return <CollapsibleContainer title="Additional Options" className="large options " storageKey="options-collapse" defaultOpen={false}>
      <Fragment>
        <div className="subsection">
          <h3>Warmup</h3>
          <hr className="divider" />
          <label className="form-row">
            Option<Dropdown values={warmupOptions} value={this.props.options.warmup} onChange={this.warmupChanged} />
          </label>
          {baseWeightsPicker}
        </div>
        <div className="subsection">
          <h3>Joker Sets</h3>
          <hr className="divider" />
          <label className="form-row">
            Add Joker Sets
            <Switch checked={this.state.showJoker} onChange={this.showJokerChanged} />
          </label>
          {jokerMaxPicker}
        </div>
        <div className="subsection">
          <h3>Deload</h3>
          <hr className="divider" />
          <label className="form-row">
            Deload After Cycle
            <Switch checked={!this.state.skipDeload} onChange={this.skipDeloadChanged} />
          </label>
          {deloadPicker}
          {deloadSkipWarmup}
        </div>
      </Fragment>
    </CollapsibleContainer>
  }
}